const KeenSlider = window.KeenSlider

const { setInitialised } = window.BAO.Carousel.plugins

class NavCarousel extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.carousel = this.setupCarousel()
  }

  setupCarousel () {
    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1500,
        },
        loop: false,
        mode: 'snap',
        slides: {
          perView: 'auto',
          spacing: 0,
        },
        breakpoints: {
          '(min-width: 1201px)': {
            disabled: true,
          },
        },
      },
      [setInitialised()],
    )
  }
}

if (!customElements.get('nav-carousel')) {
  customElements.define('nav-carousel', NavCarousel, { extends: 'nav' })
}
